import * as React from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

interface Props {
  direction: 'Ascending' | 'Descending';
  current: boolean;
  onClick: () => void;
}

const useStyles = makeStyles(() =>
  createStyles({
    button: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: 'none',
      backgroundColor: 'white',
      padding: '0',
      margin: '0',
      cursor: 'pointer',
      '& svg': {
        width: '14px',
        height: '7px'
      }
    },
    ascending: {
      paddingTop: '3px',
      paddingBottom: '1px',
      paddingLeft: '2px',
      paddingRight: '2px'
    },
    descending: {
      paddingTop: '1px',
      paddingBottom: '3px',
      paddingLeft: '2px',
      paddingRight: '2px'
    },
    disabled: {
      cursor: 'default'
    }
  })
);

const SortButton = ({ direction, current, onClick }: Props) => {
  const classes = useStyles();
  return (
    <button
      className={clsx(
        classes.button,
        direction == 'Ascending' ? classes.ascending : classes.descending,
        current && classes.disabled
      )}
      aria-label={direction}
      onClick={onClick}
      disabled={current}
    >
      {direction == 'Ascending' && (
        <svg viewBox="-100 -100 200 100">
          <polygon points="-80,-20 80,-20 0,-100" fill={current ? '#00223c' : '#c4c4c4'} strokeWidth="0" />
        </svg>
      )}
      {direction == 'Descending' && (
        <svg viewBox="-100 0 200 100" height="16px" width="16px">
          <polygon points="-80,20 80,20 0,100" fill={current ? '#00223c' : '#c4c4c4'} />
        </svg>
      )}
    </button>
  );
};

export default SortButton;
